// Конфигурация: Apache раздает статику, Node.js только API
 export const baseURL = '/easy/api'
 export const socketURL = '/' 

// Альтернативные конфигурации:
// export const baseURL = '//localhost:3002' // Локальное подключение
// export const socketURL = '//localhost:3002'

//export const baseURL = 'https://easy-server-0j8v.onrender.com'
//export const baseURL = '//192.168.1.36/api'
//export const socketURL = '//192.168.1.36'
//export const baseURL = '//192.168.1.55:3002'
//export const baseURL = '//213.57.102.46:3002' //home
